module.exports = __webpack_public_path__ + "images/paper-add.1791972770245.png";